import React from 'react';
import { StatisticsCallOutStyles as S } from './StatisticsCallOut.styles';
const StatisticsCallOut = (props) => {
    return (React.createElement(S.Container, { id: props.anchorId, paddingThickness: props.paddingThickness },
        React.createElement(S.Inner, { "data-theme": props.theme, "data-tint": props.tint }, props.statistics &&
            props.statistics.map((item) => (React.createElement(S.Statistic, { key: item.id },
                React.createElement(S.StatisticTitle, null, item.title),
                item.content && (React.createElement(S.StatisticContent, { dangerouslySetInnerHTML: { __html: item.content } }))))))));
};
export default StatisticsCallOut;
